import { render, staticRenderFns } from "./OnboardingIndex.vue?vue&type=template&id=4f188a4f&scoped=true&"
import script from "./OnboardingIndex.vue?vue&type=script&lang=js&"
export * from "./OnboardingIndex.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIndex.vue?vue&type=style&index=0&id=4f188a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f188a4f",
  null
  
)

export default component.exports